module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0121.jpg?v=d32b7d2e";